export * from './firestore';
export * from './firestore.module';
export * from './collection/collection';
export * from './document/document';
export * from './collection/changes';
export * from './observable/fromRef';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/firestore/public_api.js
// module id = 302
// module chunks = 4